var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsdoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M99.9 54.8V37l-19-17.4H23.6c-2 0-3.7 1.6-3.7 3.7V118c0 2 1.6 3.7 3.7 3.7h72.6c2 0 3.7-1.6 3.7-3.7v-5.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M80.9 19.7V37h19M117.3 103H36.2c-2.8 0-5.1-2.3-5.1-5.1V69c0-2.8 2.3-5.1 5.1-5.1h81.1c2.8 0 5.1 2.3 5.1 5.1v28.8c0 2.9-2.3 5.2-5.1 5.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M66.8 77.4V90s9.9 1.5 9.9-6.6c0 0-.4-7.8-9.9-6zM42.1 77.2v12.9M58.3 78.5s-3.3-3.1-6.8-.9c-3 2.4-.3 5.2 3.7 5.8 5.7 1 5.3 6.8-.4 7.1-4.4.4-6-2.5-6-2.5M89.8 76.8s-6.3-1.1-6.7 6.6c0 6.1 2.8 7.2 6.3 7.2 3.3 0 5.7-2.2 5.7-7.1 0-4.2-2-6.4-5.3-6.7zM111.9 77.7s-8.9-4.5-10 5.4c-.9 10.9 10 6.7 10 6.7M28.6 56.2s1.9-10.7 9-19.2C45 29.6 57 27.9 57 27.9s-.9 14.7-7.9 19.7c-8.1 6.3-20.5 8.6-20.5 8.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M41.2 32.8s-2.9-1.9-6.7-3.1-6.2-1.8-6.2-1.8 1 9.4 4.8 15.4M43.6 51.2s3 1.9 5.8 2.8c2.9 1 7 1.8 7 1.8s.3-8.3-3.4-12.6M41.8 40l3.4.4.3 3.5M47 36.3l2.4.4.3 2.3M38.4 44.3l2.3.3.4 2.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsdoc);
export default __webpack_public_path__ + "static/media/isdoc.09a7ec100756d78b9c1cb4068cdef750.svg";
export { ForwardRef as ReactComponent };